import { Card, Row } from "antd";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import React, { useContext, useEffect, useState } from "react";
import Cargando from "../../components/Cargando";
import { contextApp } from "../../firebase/context";
import { getColection } from "../../firebase/fireStore";

const Paid = () => {
  const { usuario } = useContext(contextApp);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  const getPaid = async () => {
    setLoading(true);
    const response = (await getColection("paid")) || [];
    const getdata = response.filter(
      (item) => item.data.correo === usuario.email
    );
    setData(getdata);

    setLoading(false);
    //setTopic(getdata.data.topic);
  };
  const timeToString = (fecha) => {
    const date = new Date(fecha);
    return date.toISOString().split("T")[0];
  };
  useEffect(() => {
    getPaid();
  }, []);

  return (
    <div>
      {loading && Cargando}
      <Row gutter={16}>
        {data.length > 0 ? (
          data.map((item, index) => (
            <Card
              key={index}
              style={{
                width: 300,
                height: "auto",
                marginTop: 16,
                marginLeft: 16,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div>Plan: </div>
                <div
                  style={{
                    color: "var(--secondary)",
                  }}
                >
                  {item.data.tipo && item.data.tipo}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div>Descripción: </div>
                <div
                  style={{
                    color: "var(--secondary)",
                  }}
                >
                  {item.data.plan && item.data.plan}
                </div>
              </div>
              {item.data.plan === "dúo" && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <div>Asociado dúo: </div>
                  <div
                    style={{
                      color: "var(--secondary)",
                    }}
                  >
                    {item.data.asociado && item.data.asociado}
                  </div>
                </div>
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div>Medio de pago: </div>
                <div
                  style={{
                    color: "var(--secondary)",
                  }}
                >
                  {item.data.medio && item.data.medio}
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div>Número de sesiones: </div>
                <div
                  style={{
                    color: "var(--secondary)",
                  }}
                >
                  {item.data.sesiones && item.data.sesiones}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div>Fecha de inicio: </div>
                <div
                  style={{
                    color: "var(--secondary)",
                  }}
                >
                  {item.data.inicio &&
                    format(
                      new Date(timeToString(item.data.inicio.toDate())),
                      "PPP",
                      {
                        locale: es,
                      }
                    )}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div>Fecha de fin: </div>
                <div
                  style={{
                    color: "var(--secondary)",
                  }}
                >
                  {item.data.fin &&
                    format(
                      new Date(timeToString(item.data.fin.toDate())),
                      "PPP",
                      {
                        locale: es,
                      }
                    )}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div>Pago: </div>
                <div
                  style={{
                    color: "var(--secondary)",
                  }}
                >
                  {item.data.pago && item.data.pago}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div>Costo transacción: </div>
                <div
                  style={{
                    color: "var(--secondary)",
                  }}
                >
                  {item.data.transaccion && item.data.transaccion}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div>Costo sesiones: </div>
                <div
                  style={{
                    color: "var(--secondary)",
                  }}
                >
                  {item.data.costo && item.data.costo}
                </div>
              </div>
            </Card>
          ))
        ) : (
          <div>No ha realizado ningún pago</div>
        )}
      </Row>
    </div>
  );
};

export default Paid;
